import { translate } from 'hooks/useTranslate';
import { SelectorOption } from 'types';

export const formatPartnerOptionLabel = (label: string): string => {
  const parts = label.split('|').map((part) => part.trim());

  if (parts.length < 3) return label;

  const [cif, name, sharesSegment] = parts;
  const count = sharesSegment.split(/\s+/)[0];

  if (!count) return label;

  return `${cif} | ${name} | ${count} ${translate('shares')}`;
};

export const mapPartnerOptionForDisplay = (
  option: SelectorOption | null | undefined
): SelectorOption | null => {
  if (!option) return null;

  return {
    ...option,
    label: formatPartnerOptionLabel(option.label),
  };
};

export const mapPartnerOptionsForDisplay = (
  options: SelectorOption[]
): SelectorOption[] =>
  options.map((option) => mapPartnerOptionForDisplay(option) as SelectorOption);
